import { useAvatarProfile } from '@/hooks/useAvatarProfile';
import { Avatar, AvatarFallback } from './ui/avatar';
import { AvatarProfileProps } from '@/@types/props.types';

const AvatarProfile = () => {
  const { firstLetter } = useAvatarProfile();
  return (
    <Avatar className={'h-6 w-6 text-xs bg-[#4ab0dd]'}>
      <AvatarFallback className={'bg-[#4ab0dd] text-primary-foreground font-medium'}>
        {firstLetter}
      </AvatarFallback>
    </Avatar>
  );
};
export default AvatarProfile;
